import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NHASimpleListModule } from '../simple-list/simple-list.module';

import { NHAJumpToMenuComponent } from './jump-to-menu.component';
import { NHAJumpToMenuConfiguratorComponent } from './jump-to-menu-configurator.component';
import { MatButtonModule } from '@angular/material/button';

import { NHAPipesModule } from '@nha/pipes';

@NgModule({
	imports: [
		CommonModule,
		MatButtonModule,
		MatIconModule,
		NHASimpleListModule,
		RouterModule,
		NHAPipesModule,
		NHAJumpToMenuConfiguratorComponent,
		NHAJumpToMenuComponent
	],
	exports: [NHAJumpToMenuConfiguratorComponent, NHAJumpToMenuComponent]
})
export class NHAJumpToMenuModule {}
